import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";
import { TimeServices } from "../services/functions/timeServices";

interface SingleTimePillProps {
    time: Date;
}

export const SingleTimePill = ({ time }: SingleTimePillProps) => {
    return (
        <Box display="flex" alignItems="center" gap={0.5}>
            <AccessTimeIcon sx={{ fontSize: 18, color: "#162C1F" }} />
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
                <strong>Closes</strong> {TimeServices.formatDate(dayjs(time))}
            </Typography>
        </Box>
    );
};
